// @ts-nocheck

import { mapValues as _mapValues } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses, OddsChanges } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';

const { generateSystems } = BasketUtils;

/**
 * Return the nextState corresponding to the BASKET_REFRESH action
 *
 * @param  {Object} state            The actual state.
 * @param  {Object} action           The action to reduce.
 * @param  {Object} options.entities The entities's state.
 * @return {Object}                  Return the new state.
 *
 */
const basketRefresh = (state, action, { entities }) => {
  const { status, items, systems, mode } = state;
  const { odds } = entities;
  const { force } = action.payload;
  /* force is used only in case we receive a odd value from the api response */
  if (
    (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) ||
    force
  ) {
    const nextItems = _mapValues(items, (item) => {
      const { status: itemStatus, oddId, value, cashout } = item;
      if (!cashout) {
        if (
          (itemStatus !== BasketItemStatuses.PENDING &&
            itemStatus !== BasketItemStatuses.VALIDATED &&
            itemStatus !== BasketItemStatuses.WAITING) ||
          force
        ) {
          if (odds[oddId] > 1 && odds[oddId] !== value) {
            return {
              ...item,
              previousValue: value,
              value: odds[oddId],
              changed: odds[oddId] > value ? OddsChanges.UP : OddsChanges.DOWN,
            };
          }
        }
      }
      return item;
    });

    /* regenerate system in case an outcome values  */
    let nextSystems = undefined;
    if (mode === BasketModes.SYSTEM) {
      nextSystems = generateSystems({ items: nextItems });
      /* apply existing input's check value */
      nextSystems = _mapValues(nextSystems, (system) => {
        /* check if the system was already in the previous systems */
        if (systems !== undefined && systems[system.k] !== undefined) {
          return {
            ...system,
            checked: systems[system.k].checked,
          };
        }
        return system;
      });
    }

    return {
      ...state,
      items: nextItems,
      systems: nextSystems,
    };
  }
  return state;
};

export default basketRefresh;
